import React, {createContext, useContext, useEffect} from 'react'

// Simplified Theme mode provider: enforce Light-only theme and remove persistence
export type ThemeModeType = 'light'

type ThemeModeContextType = {
  mode: ThemeModeType
  menuMode: ThemeModeType
  updateMode: (_mode: ThemeModeType) => void
  updateMenuMode: (_mode: ThemeModeType) => void
}

const defaultThemeMode: ThemeModeContextType = {
  mode: 'light',
  menuMode: 'light',
  updateMode: (_mode: ThemeModeType) => {},
  updateMenuMode: (_menuMode: ThemeModeType) => {},
}

const ThemeModeContext = createContext<ThemeModeContextType>(defaultThemeMode)

const useThemeMode = () => useContext(ThemeModeContext)

const ThemeModeProvider = ({children}: {children: React.ReactNode}) => {
  // Ensure the document theme attribute is set to light on mount
  useEffect(() => {
    try {
      document.documentElement.setAttribute('data-bs-theme', 'light')
    } catch (e) {
      // ignore in non-browser environments
    }
  }, [])

  return (
    <ThemeModeContext.Provider value={defaultThemeMode}>
      {children}
    </ThemeModeContext.Provider>
  )
}

export {ThemeModeProvider, useThemeMode}
